import classNames from 'classnames';
import { formatSubProduct, formatWrapper } from 'components/dashboard/Dashboard.helper';
import { FC } from 'react';
import { useIntl } from 'react-intl';

interface ProductProps {
  subProduct: string;
  wrapper: string;
  className?: string;
}
export const Product: FC<ProductProps> = ({ subProduct, wrapper, className }) => {
  const { formatMessage } = useIntl();
  return (
    <div
      className={classNames(
        'mx-3 d-flex text-secondary text-truncate border-top border-secondary-alpha-lg pt-2',
        className,
      )}
    >
      <span data-e2e="subproduct" title={formatMessage({ id: 'form.ProductSubtype' })}>
        {formatSubProduct(subProduct, formatMessage)}
      </span>
      <span>&nbsp;</span>
      <span data-e2e="wrapper" title={formatMessage({ id: 'form.Wrapper' })}>
        ({formatWrapper(wrapper, formatMessage)})
      </span>
    </div>
  );
};

Product.displayName = 'Product';
